import { render } from "./microsoft_sso.html?vue&type=template&id=64e1adce&external"
import script from "./microsoft_sso.js?vue&type=script&lang=js&external"
export * from "./microsoft_sso.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__